/**
 * Returns a mergeable Highmaps config object that will disable map controls
 * if in an export context.
 * @param {bool} isExporting - Whether the current view is in an export context.
 * @returns {object} - Either directives to disable map controls or an empty object.
 */
export default function disableMapControls(isExporting) {
  return (isExporting) ? {
    mapNavigation: {
      enabled: false,
    },
  } : {};
}



// WEBPACK FOOTER //
// ./app/services/disableMapControls.js